module.exports = __webpack_public_path__ + "img/icon-1.46f14729.png";